// extracted by mini-css-extract-plugin
module.exports = {"logoCompany":"LogoCompany_logoCompany__1f8m-","logo":"LogoCompany_logo__C5_I3","company":"LogoCompany_company__mXP0l"};